import { useMemo } from 'react';
import { FormattedNumber } from 'react-intl';

export const FormattedDistance = ({
  distanceInMeters
}: {
  distanceInMeters: number;
}) => {
  const [unit, value] = useMemo(() => {
    return distanceInMeters < 1000
      ? ['meter', distanceInMeters]
      : ['kilometer', Number((distanceInMeters / 1000).toFixed(1))];
  }, [distanceInMeters]);

  return <FormattedNumber style="unit" unit={unit} value={value} />;
};
